import React from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer'
// import { PDFViewer } from '@react-pdf/renderer'
import MyDocument from "./MyDocument";
import './App.css';

// reference material:
// https://github.com/diegomura/react-pdf
// https://www.npmjs.com/package/react-pdf
// https://react-pdf.org/advanced#on-the-fly-rendering

const DownLoad = () => {
    return (
        <div className="evtDownloadButton" >Click to download your results pdf &gt;</div>
    )
}

const Loading = () => {
    return (
        <div className="evtGeneratingResults">Loading your document, please wait...</div>
    )

}
function getQueryVariable(variable) {
    let query = window.location.search.substring(1);
    let vars = query.split("&");
    for (let i=0;i<vars.length;i++) {
        let pair = vars[i].split("=");
        if(pair[0] === variable){return pair[1];}
    }
    return(false);
}

class App extends React.Component {

    render() {
        let pagedata = getQueryVariable('dl');
        if(pagedata !== false) {
            let rdata = false;
            try {
               rdata = JSON.parse(atob(pagedata));
            } catch(ex) {
                rdata = false;
            }
            if(rdata !== false) {
                return (
                    <div>
                        <div className="evtDownloadContainer" id="emailresults">
                            <div className="evtDownloadTitleContainer">
                                <div className="evtDownloadTitle">
                                    Download your evaluation results and actions
                                </div>
                                <div className="evtDownloadClear"></div>
                            </div>
                            <div id="evContent" className="evtDownloadTitleContent">
                                <h1>Thank you for requesting a download of your evaluation results and actions</h1>
                                {/*<PDFViewer width='900' height='1100'>*/}
                                {/*    <MyDocument rdata={rdata}/>*/}
                                {/*</PDFViewer>*/}
                                <PDFDownloadLink document={<MyDocument rdata={rdata}/>}
                                                 fileName="Governance_Evaluator-Evaluation_Results.pdf">
                                    {({blob, url, loading, error}) => (loading ? <Loading/> : <DownLoad/>)}
                                </PDFDownloadLink>
                            </div>
                        </div>
                    </div>
                )
            } else {
                return (
                    <div>
                        <div className="evtDownloadContainer" id="emailresults">
                            <div className="evtDownloadTitleContainer">
                                <div className="evtDownloadTitle">
                                    We apologise
                                </div>
                                <div className="evtDownloadClear"></div>
                            </div>
                            <div id="evContent" className="evtDownloadTitleError">
                                <h1>An error has occured and the PDF can not be produced</h1>
                            </div>
                        </div>
                    </div>
                )
            }
        } else {
            return (
                <div>
                    <div className="evtDownloadContainer" id="emailresults">
                        <div className="evtDownloadTitleContainer">
                            <div className="evtDownloadTitle">
                                We apologise
                            </div>
                            <div className="evtDownloadClear"></div>
                        </div>
                        <div id="evContent" className="evtDownloadTitleError">
                            <h1>An error has occured and the PDF can not be produced</h1>
                        </div>
                    </div>
                </div>
            )
        }
    }
}

export default App;
